import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Icon, Label, Message, Segment } from "semantic-ui-react";
import  styles  from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/medical/";

const HealthCareLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0]);
  const [activeAccordionRightIndexes] = useState([0]);

  const renderAccordionBenefits = () => {
    return (
      <>
      <Segment raised className={styles.segmentWhiteBG} > 
        <p className={styles.learnMoreAccordionText} >
          By becoming part of the healthcare team, you can serve as another set of "eyes and 
          ears" to help notice any changes that might require a change to their current care plan.
          <br/><br/>
          Having this extra support can make a difference between good care and great care.
        </p>
      </Segment>
      </>
    );
  };
  const renderAccordionInvolved = () => {
    return (
      <>
      <Segment raised className={styles.segmentWhiteBG} >  
        <p className={styles.learnMoreAccordionText} >
          Have a conversation with them to see if they are <b>comfortable with your help</b> and with you being a part of their health care team.
          <br/><br/>
          Maintain a <b>list of their healthcare providers</b>, including contact information, to keep on hand when needed.
          <br/><br/>
          Help them <b>find a good primary care physician</b> if they don't currently have one.
          <br/><br/>
          <b>Attend</b> their healthcare appointments whenever possible.
          <br/><br/>
          Keep <b>track of any changes</b> you notice in their health or functional status.
        </p>
      </Segment>
      </>
    );
  };

  const accordions = [
    { key: 'benefits',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > What are the Benefits? </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionBenefits()}/>)
      }
    }
  ];

  const accordionsRight = [
    { key: 'involved',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Ways to Get Involved: </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionInvolved()}/>)
      }
    }
  ];

  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}HealthCareLearnMore.png)`, }}>
        <div className={styles.learnMoreModalContent}>

          <Grid stackable columns="equal" style={{width: '100%', height: '100%', paddingLeft: '1em', paddingTop: "1em"}}>
            <Grid.Column >
                <Accordion  panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </Grid.Column>
            <Grid.Column >
                <Accordion  panels={accordionsRight} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionRightIndexes} exclusive={false} />
            </Grid.Column>            
          </Grid>
        </div>
      </Segment>      
    </>
  );
};

export default observer(HealthCareLearnMore);
